import { contactFormTestId } from "../constants";
export const contactFormFieldsTestId = `${contactFormTestId}-fields`;
export const emailInputTestId = `${contactFormFieldsTestId}-email`;
export const firstNameInputTestId = `${contactFormFieldsTestId}-firstname`;
export const lastNameInputTestId = `${contactFormFieldsTestId}-lastname`;
export const messageInputTestId = `${contactFormFieldsTestId}-message`;
export const phoneNumberInputTestId = `${contactFormFieldsTestId}-phone`;
export const salutationInputTestId = `${contactFormFieldsTestId}-salutation`;
export const streetInputTestId = `${contactFormFieldsTestId}-street`;
export const zipInputTestId = `${contactFormFieldsTestId}-zipCode`;
export const cityInputTestId = `${contactFormFieldsTestId}-city`;
